import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";
import { Layers, Briefcase, Tag } from "lucide-react";

const PIE_COLORS = [
  "#6366f1",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#ec4899",
  "#06b6d4",
  "#ef4444",
  "#84cc16",
];

function CardWrap({ icon: Icon, title, children, subtitle }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <Icon size={16} className="text-gray-500" />
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        {subtitle && (
          <span className="text-xs text-gray-400 ml-auto">{subtitle}</span>
        )}
      </div>
      {children}
    </div>
  );
}

function EmptyState({ message }) {
  return (
    <div className="h-48 flex items-center justify-center text-sm text-gray-400">
      {message}
    </div>
  );
}

function BlocksChart({ data }) {
  const total = data.reduce((s, d) => s + d.count, 0);
  if (total === 0) return <EmptyState message="Sin datos de progreso" />;

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
      >
        <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11 }} />
        <YAxis
          type="category"
          dataKey="name"
          width={110}
          tick={{ fontSize: 11 }}
        />
        <Tooltip
          formatter={(value) => [`${value} alumnos`, "Cantidad"]}
          labelStyle={{ fontSize: 12 }}
          contentStyle={{ fontSize: 12, borderRadius: 8 }}
        />
        <Bar dataKey="count" fill="#6366f1" radius={[0, 6, 6, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}

function DonutChart({ data }) {
  if (data.length === 0) return <EmptyState message="Sin datos" />;

  return (
    <ResponsiveContainer width="100%" height={220}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius={45}
          outerRadius={75}
          paddingAngle={2}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value, name) => [`${value} alumnos`, name]}
          contentStyle={{ fontSize: 12, borderRadius: 8 }}
        />
        <Legend
          wrapperStyle={{ fontSize: 11 }}
          iconType="circle"
          iconSize={8}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default function DistributionCharts({
  byBlock,
  byProgram,
  byStage,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <CardWrap icon={Layers} title="Por bloque actual">
        <BlocksChart data={byBlock} />
      </CardWrap>
      <CardWrap icon={Briefcase} title="Por programa">
        <DonutChart data={byProgram} />
      </CardWrap>
      <CardWrap icon={Tag} title="Por estado">
        <DonutChart data={byStage} />
      </CardWrap>
    </div>
  );
}
